import { DateTime } from 'luxon';

export const getDateStrWithTimezone = (
    date: Date,
    timezone?: string | null
) => {
    return DateTime.fromJSDate(
        date,
        timezone
            ? {
                  zone: timezone,
              }
            : undefined
    ).toFormat('MM/dd/yyyy, HHmm ZZZZ');
};
